import React, { useContext, useEffect, useState } from 'react'
import './index.scss';
import { LOCAL_COMPANY } from '@/util/constants';
import { UserInfoContext } from '@/page/developer/components/header';

export default function FeatureCards(props) {
    const { feature } = props;
    const [activeSubIndex, setActiveSubIndex] = useState(0)
    const companyId = localStorage.getItem(LOCAL_COMPANY);
    const user = useContext(UserInfoContext);
    
    useEffect(() => {
        console.log('feature', feature);
        
        setActiveSubIndex(0);
    }, [feature])

    useEffect(() => {
        const currentFeature = feature.children[activeSubIndex];
        console.log('currentFeature', currentFeature);
        if (currentFeature?.omega) {
            const { id, remark } = currentFeature.omega;
            // 上报曝光
            Omega?.trackEvent(id, remark, {
                host: location.hostname,
                pub_comanyid: companyId,
                pub_jieru_uid: user?.uid
            });
        }
    }, [feature?.title, activeSubIndex, user?.uid]);
    
    
    
    return (
        <div className="feature-cards">
            <div className='cards-fixed-width'>
            <div className="feature-cards__text">
                <div className="feature-cards__title">{feature.subTitle}</div>
                <div className={'feature-cards__tab'}>
                    {feature.children.map((it, idx) => (
                        <div 
                            className={`feature-cards__tab-title ${activeSubIndex === idx ? 'active' : ''}`}
                            key={idx}  
                            onClick={() => setActiveSubIndex(idx)}
                        >
                            {it.title}
                        </div>
                    ))}
                </div>
                <div className='feature-cards__tab-highlight'>
                    亮点介绍
                </div>
                <div className="feature-cards__tab-hint">{feature.children[activeSubIndex]?.hint}</div>
            </div>
            <div style={{ backgroundImage: `url(${feature.children[activeSubIndex]?.href})` }} className="feature-cards__img">
            </div>
            </div>
        </div>
    )
}
